import { makeAutoObservable } from 'mobx';
import { TeamMembersApi } from './TeamMembersApi';
import type { InviteTeamMemberParamDTO, TeamMemberRowDTO } from './TeamMembersType';

export class TeamMembersModel {
  loading = false;
  submitting = false;
  members: TeamMemberRowDTO[] = [];
  teamName = '';
  inviteForm: InviteTeamMemberParamDTO = {
    phone: '',
    realName: '',
    nickname: '',
  };

  constructor() {
    makeAutoObservable(this);
  }

  load = async (): Promise<void> => {
    this.loading = true;
    try {
      const detail = await TeamMembersApi.getTeamDetail();
      this.teamName = detail?.teamName || '';
      this.members = detail?.userList || [];
    } finally {
      this.loading = false;
    }
  };

  invite = async (): Promise<boolean> => {
    this.submitting = true;
    try {
      const ok = await TeamMembersApi.inviteMember({
        phone: this.inviteForm.phone.trim(),
        realName: this.inviteForm.realName.trim(),
        nickname: this.inviteForm.nickname?.trim() || undefined,
      });
      if (ok) {
        this.inviteForm = { phone: '', realName: '', nickname: '' };
        await this.load();
      }
      return ok;
    } finally {
      this.submitting = false;
    }
  };

  remove = async (sellerId: string): Promise<boolean> => {
    const ok = await TeamMembersApi.removeMember(sellerId);
    if (ok) {
      await this.load();
    }
    return ok;
  };
}
